import React, {useEffect, useMemo, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import Styles from './index.module.scss'
import NFTModal from "@/components/NFTModal";
import ActivityRules from "../components/ActivityRules";
import Service from "../service"
import {hideLoading, showLoading} from "@/components/loading";
import {Toast} from "antd-mobile";
import JsBridgeNew from "@/utils/jsbridgeNew";
import {objectToQueryParams} from "@/utils/publicFun";
import qs from "query-string";
import { copyText} from "@/utils/publicFun"

/**
 * @description 茅台二期
 * @return {/culturalExchange_maotaisecond/home}
 */
const Btns = [
  { title: '规则', key: 1 }, { title: '实名', key: 2 },
]
const Home = () => {
  const pageDom = useRef(null);
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState({});
  const [data, setData] = useState({});
  const [hasPermission, setHasPermission] = useState(false)
  // const [shiwuThing, setShiwuThing] = useState({})
  const { nftNo } = qs.parse(window.location.search);
  const [detailData, setDetailData] = useState({})
  const [show,setShow] = useState(false)//兑换弹窗
  const [exchangeCode,setExchangeCode] = useState("")//输入的兑换码
  const [showTip, setShowTip] = useState(false)//提示框显示状态
  const [recData, setRecData] = useState({})//兑换信息
  const [pageType, setPageType] = useState(2)//页面类型 1:普通款 2:稀有款
  const [flag, setFlag] = useState(2)//页面类型 1:普通款 2:稀有款
  const [showRedeemCodeModal, setShowRedeemCodeModal] = useState(false)//兑换码弹窗
  const [redeemCodes, setRedeemCodes] = useState([])//兑换码列表

  const batchList = useMemo(() => {
    const map = {
      1: [
        { title: '优先购', lines: ['11月21日', '10:00-22日10:00'] },
        { title: '公开购', lines: ['11月22日', '13:00-24日24:00'] },
      ],
      2: [
        { title: '第一批', lines: ['11月25日', '10:00-26日10:00'] },
        { title: '第二批', lines: ['根据持仓情况', '待定'] },
      ],
    };
    return map[pageType] || map[2];
  }, [pageType]);

  useEffect(() => {
    (()=>{
      getData(true);
      onDidFocus();
      // getData2()
    })()

  }, []);
//   const getData2 = async () => {
//     try {
//         showLoading()
//         const res = await Service.getGoodsDetail({collectionId: Service.collectionId})
//         hideLoading();
//         if (res.code !== '000000') throw res.msg;
//         if (res.data && res.data.info) {
//             setDetailData(res.data.info)
//         }
//     } catch (error) {
//         Toast.show(error);
//     }
  
// }
  const onDidFocus = () => {
    window.JsBridge.addListener().then(() => {
      getData(true)
      onDidFocus();
    });
  }
  const getData = async (loading = false) => {
    // const res2 = await Service.getGoodsData({},nftNo);
    try {
      if (loading) showLoading();
      if (loading) {
        const userInfoRes = await Service.getUserCertificateStatus();
        // const accessRes = await Service.purchasePermissions();
        setUserInfo(userInfoRes);
        
        // console.log(accessRes.data, accessRes.data.isPermission);
        // const res2 = await Service.getGoodsData({},nftNo);
        // if(res2?.data?.length > 0){
        //   const shiwu = res2.data.find(item => item?.goodsType === 3)
        //   console.log('shiwu===>', shiwu)
        //   setShiwuThing(shiwu)
        // }
      }
      const res = await Service.getInitData();
      if (loading) hideLoading();
      if (res.code !== '000000') throw res.msg;
      setData(res.data);
      setHasPermission(res.data?.isPermission)
      setPageType(parseInt(res.data?.flag) || 2)
      setFlag(parseInt(res.data?.flag) || 2)
    } catch (error) {
      hideLoading();
      Toast.show(error);

    }
  }
  const onBack = () => {
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.back();
    } else {
      navigate(-1);
    }
  }
  // 提示信息
  const tipsMessage = useMemo(() => {
    let msg = undefined;
    const { systemTime, startTime, endTime } = data;
    const currentT = new Date(systemTime?.replace(/-/g, "/")).getTime();
    const startT = new Date(startTime?.replace(/-/g, "/")).getTime();
    const endT = new Date(endTime?.replace(/-/g, "/")).getTime();
    if (!startTime || !endTime) {
      msg = "接口异常";
    } else if (currentT < startT) {
      msg = "活动未开始";
    } else if (currentT > endT) {
      msg = "活动已结束";
    }

    return msg;
  }, [data]);

  const buyHandle = () => {
    if(!hasPermission||pageType !== flag){
      return;
    }
    // const bynum = pageType === 1 ? (data?.ordNum || 0) : pageType === 2?(data?.rareNum || 0):0;
    // if(bynum === 0){
    //   Toast.show("超过购买数量");
    //   return;
    // }
    if (tipsMessage) {
      Toast.show(tipsMessage);
      return;
    }
    if (!userInfo?.ID) {
      Toast.show("请先实名认证");
      return;
    }
    const uri = `/ape/saleDetail?collectionId=${pageType === 1 ? Service.collectionId_common : Service.collectionId_uncommon}&code=${Service.activityCode}`;
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.push("CustomWeb", {
        uri: `${window.location.origin}${uri}`,
      });
    } else {
      navigate(uri);
    }
    
  }
  const gotoSalePay = () => {
    const params = {
      collectionId:detailData.collectionId,
      saleBatchId:detailData.saleBatchInfo?.saleBatchId || '',
      code: Service.activityCode,
    }
    
    if (window.JsBridge.hasWebViewBridge()) {
        window.JsBridge.push("Web", { uri: `${window.location.origin}/ape/PayPage?${qs.stringify(params)}` });
    } else {
      navigate(`/ape/PayPage?${qs.stringify(params)}`);
    }
  }
  const onRightBtnClick = (item) => {
    if (item.key === 1) {
      const ModalInstance = NFTModal.show({
        content: <ActivityRules onClose={() => ModalInstance?.close()} />,
        getContainer: pageDom.current,
      });
    } else if (item.key === 2) {
      window.JsBridge.navigate('Verify');
    }
  }
  const toRecord = () => {
    const uri = `/culturalExchange_maotaisecond/collectionRecord`
    if(uri){
      navigate(uri);
    }
  }
  const toExchange = () => {
    const uri = `/culturalExchange_maotaisecond/exchangepage`
    if(uri){
      navigate(uri);
    }
    // if (window.JsBridge.hasWebViewBridge()) {
    //   window.JsBridge.push("CustomWeb", {
    //     uri: `${window.location.origin}${uri}`,
    //   });
    // } else {
    //   navigate(uri);
    // }
  }
  const exChange = () => {
    setShow(true);
  }
  const toggleTip = () => {
    setShowTip(!showTip);
  }
  const inputChange = (e) =>{
    setExchangeCode(e.target.value);
  }
  const comfirmExChange = async () =>{
    if(!exchangeCode){
      Toast.show("请输入兑换码")
      return
    }
    const res = await Service.checkRedeemCode(exchangeCode);
    if (res.status === 1){
      setShow(false);
      const userInfo = await JsBridgeNew.getCurrentUserInfo();
      const param = objectToQueryParams({
        idf: 'exchangeCultural_seasons',
        activityCode: Service.activityCode,
        req: data?.defaultGoods?.id,
        name: data?.defaultGoods?.goodsName,
        imgUrl: data?.defaultGoods?.imgUrl,
        productId:data?.defaultGoods?.goodsId,
        isChangeName:0,
        clientId: userInfo?.clientId,
        skUId: data?.defaultGoods?.goodsId,
        prizeImgUrl: data?.defaultGoods?.imgUrl,
        prizeName: data?.defaultGoods?.goodsName,
        nftNo: nftNo,
        needShowCount:1,
        remark:exchangeCode,
      });
      window.JsBridge.push('CustomWeb', { uri:`${process.env.REACT_APP_GKT_LINK}/front/guapp/activityOrder?${param}`});
    }
    onDidFocus();
  }
  //复制兑换码
  const copyRedeemCode = (code) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(() => {
        Toast.show('复制成功');
      }).catch(() => {
        // 降级方案
        const textArea = document.createElement('textarea');
        textArea.value = code;
        textArea.style.position = 'fixed';
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          Toast.show('复制成功');
        } catch (err) {
          Toast.show('复制失败，请手动复制');
        }
        document.body.removeChild(textArea);
      });
    } else {
      // 降级方案
      const textArea = document.createElement('textarea');
      textArea.value = code;
      textArea.style.position = 'fixed';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      textArea.select();
      try {
        document.execCommand('copy');
        Toast.show('复制成功');
      } catch (err) {
        Toast.show('复制失败，请手动复制');
      }
      document.body.removeChild(textArea);
    }
  };

  //立即领取 ，显示兑换码弹窗
  const handleToOrder = async (type) => {
    // setRedeemCodes(['112','12112']);
    // setShowRedeemCodeModal(true);
    //type 1 去领取 2 查看详情
    if(type === 1 && !data?.badgeFlag) {
      Toast.show('请先持有欧皇徽章')
      return
    }
    // 显示兑换码弹窗
      // 这里可以从接口获取兑换码，暂时使用模拟数据
    const res = await Service.GetRedeemCode();
    if (res?.data?.redeemCode?.length>0){
      setRedeemCodes(res.data?.redeemCode);
      setShowRedeemCodeModal(true);
    }
    // onDidFocus();
  }
  return (
    <div className={Styles.culturalExchangeHome} ref={pageDom}>
       <div className={Styles.topCard}>

      </div>
      <div className={Styles.back} onClick={onBack}></div>
      <div className={Styles.right_btns}>
        {
          Btns.map((btn, i) => {
            if (btn.key === 2 && userInfo?.ID) return null;
            return (
              <div key={i} className={Styles.rightBtn} onClick={() => onRightBtnClick(btn)}>{btn.title}</div>
            )
          })
        }
      </div>
      <div className={Styles.hintBtnBox}>
          <div className={Styles.hintBtn1} style={{ filter: pageType === 1 ? '' : 'grayscale(1)'}} onClick={() => setPageType(1)}>
            {/* <button disabled={!hasPermission} onClick={buyHandle}>立即购买</button> */}
          </div>
          <div className={Styles.hintBtn2} style={{ filter: pageType === 2 ? '' : 'grayscale(1)'}} onClick={() => setPageType(2)}>
          {/* <button disabled={!hasPermission} onClick={buyHandle}>立即购买</button> */}
        </div>
      </div>
      {!!batchList.length && (
        <div className={Styles.batchInfoBox}>
          {batchList.map((item, index) => (
            <div className={Styles.batchItem} key={`${item.title}-${index}`}>
              <div className={Styles.batchTitle}>{item.title || `第${index + 1}批`}</div>
              {(item.lines && item.lines.length
                ? item.lines
                : ['待定']
              ).map((line, lineIndex) => (
                <div className={Styles.batchLine} key={lineIndex}>{line}</div>
              ))}
            </div>
          ))}
        </div>
      )}
      <div className={Styles.imagebox}>
        <img src={pageType === 1 ? require('@/assets/img/culturalExchange_onplane/common@2x.png') : require('@/assets/img/culturalExchange_onplane/uncommon@2x.png')} alt="image" />
      </div>
      <div className={Styles.buyBtn} style={{ filter: pageType===flag&&hasPermission ? '' : 'grayscale(1)'}} onClick={buyHandle} disabled={pageType===flag&&hasPermission?false:true}>
        {/* <button disabled={!hasPermission} onClick={buyHandle}>立即购买</button> */}
      </div>
      {/* <button className={Styles.myCollectionsBtn} onClick={toMyGuards}>我的藏品{">"}</button> */}
      {/* {data?.priFlag && <div className={Styles.textCount}>剩余可购买数量：{data?.priNum || 0}</div>} */}
      <div className={Styles.textCount}>剩余可购买数量：{pageType === 1 ? (data?.ordNum || 0) : pageType === 2?(data?.rareNum || 0):0}</div>

      <div className={Styles.centerCard}>
        <div className={Styles.centerCardBox1}>
            <div className={Styles.context}>
              <div className={Styles.lefttem}>
                  <div className={Styles.leftItem1}>
                    欧皇徽章权益领取
                  </div>
              </div>
              <div className={Styles.rightItem}>
                  {!data?.hasBadgeFlag && <div className={Styles.leftItem2} style={{ filter: data?.badgeFlag ? '' : 'grayscale(1)'}} onClick={()=>handleToOrder(1)}></div>}
                  {data?.hasBadgeFlag &&<div className={Styles.leftItem3} onClick={()=>handleToOrder(2)}>查看详情{'>'}</div>}
              </div>
            </div>
        </div>

        <div className={Styles.centerCardBox5}>
        </div>

          <div className={Styles.footerBox}>
            <div className={Styles.footer}></div>
          </div>
      </div>


          {
                show?<div className={Styles.modal}>
                    <div className={Styles.modelShadow} onClick={()=>setShow(false)}></div>
                    <div className={Styles.content1}>
                        <div className={Styles.title}>权益兑换</div>
                        <div className={Styles.hintbox}>
                          <span>您可领取： </span>
                          <br/>
                          <span>1. 满500减150*1张、满200减50*1张、满100减</span>
                          <br/>
                          <span>20*1张，可用于G优商城消费抵扣</span>
                          <br/>
                          <span>2. 胡椒树葡萄酒一瓶</span>
                        </div>
                        <div className={Styles.inputTitle}>请输入巽风平台提供的兑换码</div>
                        <input className={Styles.input} placeholder="请输入兑换码" onChange={inputChange} inputMode="text" autoComplete="off" autoCorrect="off" autoCapitalize="off"></input>
                        <div className={Styles.hintTitle}>温馨提示：每个兑换码仅能兑换一次哦</div>
                        <div className={Styles.confirmBtn} >
                          <button className={Styles.confirmBtnTitle} onClick={comfirmExChange}>确认兑换</button>
                        </div>
                    </div>
                </div>:null
              }
          {
            showRedeemCodeModal ? (
              <div className={Styles.modal}>
                <div className={Styles.modelShadow} onClick={() => setShowRedeemCodeModal(false)}></div>
                <div className={Styles.redeemCodeModal}>
                  <div className={Styles.closeBtn} onClick={() => setShowRedeemCodeModal(false)}>
                    <img src={require('@/assets/img/culturalExchange_onplane/close@2x.png')} alt="关闭" />
                  </div>
                  <div className={Styles.redeemCodeTitle}>兑换码</div>
                  <div className={Styles.redeemCodeList}>
                    {redeemCodes.map((code, index) => (
                      <div key={index} className={Styles.redeemCodeItem}>
                        <span className={Styles.redeemCodeText}>{code}</span>
                        {/* <div className={Styles.copyIcon} onClick={() => copyRedeemCode(code)}>
                          <img src={require('@/assets/img/culturalExchange_onplane/copy@2x.png')} alt="复制" />
                        </div> */}
                        <div className={Styles.copyIcon} id="copyURL" onClick={() => copyText(code|| "", document.getElementById("copyURL"))}></div>
                      </div>
                    ))}
                  </div>
                  <div className={Styles.redeemCodeHint}>
                    请复制兑换码前往「在机场」app 兑换
                  </div>
                </div>
              </div>
            ) : null
          }
    </div>
  )
}
export default Home
